<template>
  <div>
    <b-button type="is-success" style="margin: 20px"  @click="isComponentModalActive = true">Neuen Eintrag</b-button>
    
    <b-modal :active.sync="isComponentModalActive"  can-cancel trap-focus has-modal-card>
      <adminNew></adminNew>
    </b-modal>

    <b-table :data="posts" style="margin: 0 20px" detailed striped>
      <template slot-scope="props">

        <b-table-column field="name" label="Name">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="name" label="Titel">
          {{ props.row.title }}
        </b-table-column>
        
      </template>

      <template slot="detail" slot-scope="props">
        <b-field grouped>
          <b-field label="Name">
            <b-input v-model="props.row.name"></b-input>
          </b-field>

          <b-field label="Hervorheben?">
            <b-checkbox v-model="props.row.featured"><span v-if="props.row.featured === true">Ja</span><span v-else>Nein</span></b-checkbox>
          </b-field>

          <b-field label="Titel">
            <b-input v-model="props.row.title"></b-input>
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field label="Tags">
            <b-select multiple native-size="6" v-model="props.row.tags">
              <option v-for="tag in tag_collection" v-bind:value="tag" v-bind:key="tag" >{{tag}}</option>
            </b-select>
          </b-field>

          <b-field label="Beschreibung">
            <b-input v-model="props.row.description"  maxlength="10000" type="textarea"></b-input>
          </b-field>

          <b-field label="Adresse">
            <b-input v-model="props.row.address" maxlength="1000" type="textarea"></b-input>
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field label="Telefon">
            <b-input v-model="props.row.telephone"></b-input>
          </b-field>
          
          <b-field label="E-Mail">
            <b-input v-model="props.row.email" type="email"></b-input>
          </b-field>
        
          <b-field label="Website">
            <b-input v-model="props.row.url" type="url"></b-input>
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field label="Kosten">
            <b-input v-model="props.row.cost" maxlength="1000" type="textarea"></b-input>
          </b-field>

          <b-field label="Anfahrt">
            <b-input v-model="props.row.approach" maxlength="1000" type="textarea"></b-input>
          </b-field>

          <b-field label="Öffnungszeiten">
            <b-input v-model="props.row.hours" maxlength="1000" type="textarea"></b-input>
          </b-field>
        </b-field>
        <b-field grouped>
          <section>
            <b-field label="Bild">
              
              <section>
                <img v-if="props.row.image" :src="props.row.image" width="200" style="padding-right: 20px; float:left;"/>
    
                <b-upload v-model="newimage" drag-drop>
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>Bild hier ersetzen</p>
                    </div>
                  </section>
                </b-upload>
              </section>

            </b-field>

            <b-field label="Datei">
              
              <section>
                <b-upload v-model="newfile" drag-drop>
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>Datei hier ersetzen</p>
                    </div>
                  </section>
                </b-upload>
              </section>

            </b-field>
          </section>
        </b-field>

        <b-field>
          <b-field label="Bezirk">
            <b-input v-model="props.row.district"></b-input>
          </b-field>

          <b-field label="Position">
            <section>
              <b-input v-model="props.row.lat" placeholder="lat" style="width: 45%"></b-input>
              <b-input v-model="props.row.long" placeholder="long" style="width: 45%"></b-input>
            </section>
          </b-field>
        </b-field>

        <b-button type="is-success" @click="save(props.row)">Speichern</b-button>

      </template>
    </b-table>
  </div>
</template>


<script>
import db from "../db"
import firebase from "firebase"
import adminNew from '@/components/admin-new'

export default {
  name: "admin",
  data() {
    return {
      tag_collection:[],
      newimage: null,
      newfile:null,
      isComponentModalActive: false
    }
  },
  components: {
    adminNew
  },
  firestore: {
    posts: db.collection('posts')
  },
  created:function () {
      fetch("tag_collection.json")
        .then(r => r.json())
        .then(json => {this.tag_collection = json.tags})
  },
  methods: {
    async save(row) {
    
      var storageRef = firebase.storage().ref()

      // save new image  
      if (this.newimage) {
        
        // delete old one
        if (row.image) {
          var oldImageRef = firebase.storage().refFromURL(row.image);

          // Delete the file
          oldImageRef.delete().then(function() {
            console.log('deleted old image')
          })
        }

        // upload image and get download url 
        var imageRef = storageRef.child('posts/'+ this.$uuid.v4() + '/' + this.newimage.name)
        var imageURL = await imageRef.put(this.newimage).then(function() {
          return imageRef.getDownloadURL().then(function(url){return url})
        })
        row.image = imageURL
      }

        // save new file  
      if (this.newfile) {
        
        // delete old one
        if (row.file) {
          var oldFileRef = firebase.storage().refFromURL(row.file);

          // Delete the file
          oldFileRef.delete().then(function() {
            console.log('deleted old file')
          })
        }

        // upload image and get download url 
        var fileRef = storageRef.child('posts/'+ this.$uuid.v4() + '/' + this.newfile.name)
        var fileURL = await fileRef.put(this.newfile).then(function() {
          return fileRef.getDownloadURL().then(function(url){return url})
        })
        row.file = fileURL
      }

      db.collection('posts').doc(row.id).set(row).then(() => {console.log('post wurde aktualisiert')})

      this.$buefy.snackbar.open(`Gespeichert!`)
    },
  }
};
</script>

<style lang="scss" scoped>

@import '@/assets/styles/main.scss';

.field {
  max-width: 300px;
  margin-left: 20px;
}

</style>
